import React from 'react';

import './TextInput.scss';
import {Input, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    inputStyles: (props: any) => ({
        width: `100%`,
        lineHeight: `1`,
        // backgroundColor: '#ffffff',
        border: `1px solid ${props.bordersColor}`,
        borderRadius: "5px",
        "&.MuiInputBase-multiline": {
            padding: `0`,
        },
        "&.MuiInput-root": {
            '& > input': {
                // fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                padding: `12px`,
                borderRadius: "5px",
                // height: "48px",
                // lineHeight: `1`,
            },
            '& > textarea': {
                // fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                padding: `5px`,
                // lineHeight: `1`,
            }
        },
        "&.requiredField": {
            borderLeft: `4px solid #E5870E`,
            borderRadius: `0 5px 5px 0`,
        },
        "&.notValid": {
            borderLeftColor: `red`,
        },
        "&.Mui-disabled": {
            backgroundColor: `#dbdbdb`,
        },
    }),

}))

interface ITextInput {
    value?: string;
    label?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    errorMessage?: string;
    type?: string;
    disabled?: boolean;
    verticalMode?: boolean;
    horizontalLabelCol?: string;
    horizontalInputCol?: string;
    maxLength?: number;
    readOnly?: boolean;
    placeHolder?: string;
    isRequired?: boolean;
    bordersColor?: string;
    withoutErrorMessage?: boolean;
}

const TextInput: React.FC<ITextInput> = (props) => {
    const properties = {
        bordersColor: props.bordersColor || "#888888"
    }
    const classes = useStyles(properties);
    return (
        // vertical mode
        <>
            {props.verticalMode &&

                <div className="generic_text_input">
                    {props.label && <label className="generic_text_input_label form-label">{props.label}</label>}
                    <Input
                        type={props.type ? props.type : 'text'}
                        className={`${classes.inputStyles} ${props.isRequired ? `requiredField` : ''} ${props.errorMessage && props.isRequired ? 'notValid' : ''}`}
                        value={props.value}
                        onChange={props.onChange}
                        disabled={props.disabled}
                        inputProps={{maxLength: props.maxLength ? props.maxLength : -1}}
                        // maxLength={props.maxLength ? props.maxLength : -1}
                        readOnly={props.readOnly}
                        autoComplete="off"
                        disableUnderline
                        placeholder={props.placeHolder || ""}
                        sx={{
                            padding: "0",
                            height: "inherit"
                        }}
                    />
                    {
                        !props.withoutErrorMessage &&
                        <Typography height={"24px"} m={"4px 12px"} fontSize={"14px"}
                                    color={"#FF0404"}>{Boolean(props.errorMessage) ? props.errorMessage : ''}</Typography>
                    }
                </div>
            }

            {!props.verticalMode &&

                <div className="generic_text_input row">
                    <div className={props.horizontalLabelCol}>
                        {props.label && <label className="generic_text_input_label form-label">{props.label}</label>}
                    </div>
                    <div className={props.horizontalInputCol}>
                        <Input
                            type={props.type ? props.type : 'text'}
                            className={`${classes.inputStyles} ${props.isRequired ? `requiredField` : ''} ${props.errorMessage && props.isRequired ? 'notValid' : ''}`}
                            value={props.value}
                            onChange={props.onChange}
                            disabled={props.disabled}
                            inputProps={{maxLength: props.maxLength ? props.maxLength : -1}}
                            // maxLength={props.maxLength ? props.maxLength : -1}
                            readOnly={props.readOnly}
                            autoComplete="off"
                            placeholder={props.placeHolder || ""}
                            disableUnderline
                            sx={{
                                padding: "0",
                                height: "inherit"
                            }}
                        />
                        {
                            !props.withoutErrorMessage &&
                            <Typography height={"24px"} m={"4px 12px"} fontSize={"14px"}
                                        color={"#FF0404"}>{Boolean(props.errorMessage) ? props.errorMessage : ''}</Typography>
                        }
                    </div>
                </div>
            }
        </>
        // horizontal
    )
}

TextInput.defaultProps = {
    verticalMode: true,

    horizontalLabelCol: 'col-sm-3',
    horizontalInputCol: 'col-sm-9',

    readOnly: false,
}

export default TextInput;